<template>
  <div>
    <ApprovedPrs/>
  </div>
</template>
  
  <script>
  // @ is an alias to /src
  import ApprovedPrs from '@/components/ApprovedPrs.vue'
  
  export default {
    name: 'penidng-approval-view',
    components: {
      ApprovedPrs
    }
  }
  </script>
  